import React, { Component, Fragment } from 'react';
import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';
import toastr from 'toastr';
import axios from 'axios';

class AlbumsForm extends Component {

    constructor(props){
        super(props);
        const {title, description } = this.props;

        this.state = {
            album_id: '',
            album_title: new String,
            description: new String,
            image : '',
            progress : 0,
            uploading : true,
            supported_mime : [
                'image/jpeg',
                'image/png',
            ]
        }
    }

    componentDidMount(props) {
        const { id, title, description } = this.props.album

        this.setState({
            album_id: id,
            album_title: title,
            description: description
        });
    }

    onChange(e) {
        this.setState({ [e.target.name]:e.target.value});
    }

    onDrop(image){
        this.setState({
            image
        });
    }

    onDropRejected(image){
        if(image.length){
            toastr.error('Please upload valid image files. Supported extension JPEG and PNG', 'Invalid MIME type')
        }
    }

    removeDroppedFile(preview, e = null){
        this.setState({
            image : this.state.image.filter((image) => {
                return image.preview !== preview
            })
        })
    }

    uploadFiles(){
        let image = this.state.image,
            id = this.state.album_id,
            album_title = this.state.album_title,
            description = this.state.description,
            config = { headers: { 'Content-Type': 'multipart/form-data' } },
            total_files = this.state.image.length,
            uploaded = 0;

        this.setState({
            uploading : true
        });

        if (id) {
            image.map((image) => {

            let formData = new FormData();
            formData.append("file", image);
            formData.append("album_id", id);
            formData.append("album_title", album_title);
            formData.append("description", description);
            axios.post(`/album/${id}/update`, formData, config)
                .then(response => {
                    const done = response.data;
                    if(done){
                        this.removeDroppedFile(image.preview);
                        this.calculateProgress(total_files, ++uploaded);
                        this.setState({ id, album_title, description });
                        this.props.getAlbum(response.data);
                    }
                })
                .catch(e => console.log(e));
            });
        } else {
            image.map((image) => {
                let formData = new FormData();
                formData.append("file", image);
                formData.append("album_title", album_title);
                formData.append("description", description);

                axios.post("/albums/create", formData, config)
                    .then(response => {
                        const done = response.data;
                        if(done){
                            this.removeDroppedFile(image.preview);
                            this.calculateProgress(total_files, ++uploaded);
                            this.setState({album_title: '', description: ''});
                        }
                    })
                    .catch(e => console.log(e));
            });
        }
    }

    calculateProgress(total, uploaded){
        let percentage = (uploaded / total) * 100;
        this.setState({
            progress : percentage,
            uploading : percentage !== 100
        });

        if(percentage === 100){
            toastr.success('Album successfully created');
        }
    }

    render() {
        const { title, description} = this.props.album;

        return (
            <div className="uploader container">
                <div className="form-group text-center">
                        <label htmlFor="album_title">Album title</label>
                        <input
                            type="text"
                            name="album_title"
                            className="form-control"
                            onChange={this.onChange.bind(this)}
                            value={this.state.album_title || '' }
                            placeholder={title || "Enter the album title"}/>
                </div>
                <div className="form-group text-center">
                    <label htmlFor="description">Description</label>
                    <textarea
                        type="text"
                        name="description"
                        className="form-control"
                        onChange={this.onChange.bind(this)}
                        value={this.state.description || ''}
                        placeholder={description || "Album description"}></textarea>
                </div>

                <div className="text-center">
                    <Dropzone
                        onDropAccepted={this.onDrop.bind(this)}
                        onDropRejected={this.onDropRejected.bind(this)}
                        multiple={false}
                        className="btn btn-dark"
                        accept={this.state.supported_mime}
                    >
                        Select Images
                    </Dropzone>

                    {this.state.image.length > 0 &&
                        <button
                            className="btn btn-dark uploadBtn"
                            onClick={this.uploadFiles.bind(this)}
                        >
                            Upload
                        </button>
                    }
                </div>

                {this.state.image.length ?
                    <Fragment>
                        {this.state.uploading &&
                            <div className="progress">
                                <div
                                    className="progress-bar"
                                    role="progressbar"
                                    style={{width : this.state.progress}}
                                    aria-valuenow={this.state.progress}
                                    aria-valuemin="0"
                                    aria-valuemax="100"/>
                            </div>
                        }

                        <div className="images">
                            {
                                this.state.image.map((file) =>
                                    <div key={file.preview} className="image">
                                        <span
                                            className="close"
                                            onClick={this.removeDroppedFile.bind(this, file.preview)}
                                        >X</span>
                                        <img src={file.preview} alt=""/>
                                        <img src={this.state.image} alt=""/>
                                    </div>
                                )
                            }
                        </div>
                    </Fragment>
                    :
                    <div className="no-images">
                        <h5 className="text-center">
                            Selected image will appear here
                        </h5>
                    </div>
                }

            </div>
        );
    }
}

AlbumsForm.propTypes = {
    album : PropTypes.object,
    getAlbum: PropTypes.func
}

export default AlbumsForm;


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/AlbumsForm.js